<template>
  <fragment>
    <v-row dense class="pa-2">
      <v-col
        v-for="tipo in tipos"
        :tipo="tipo"
        :key="tipo.value"
        cols="12"
        sm="12"
        md="12"
        lg="12"
      >
        <v-col v-if="tipo.check" cols="12" sm="12" md="12" lg="12">
          <v-card-title class="fontDash-title"
            >{{ tipo.text }}
            <template v-if="tipo.headerButtons">
              <v-btn
                color="#fff"
                fab
                x-small
                elevation="2"
                class="ml-3 mr-3"
                :loading="refreshLoading"
                @click.stop="refreshEvents"
              >
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
              <v-btn
                color="#fff"
                fab
                x-small
                @click="expand = !expand"
                class="mr-3"
                elevation="2"
              >
                <v-icon color="black">mdi-magnify</v-icon>
              </v-btn>
              <v-expand-x-transition transition="slide-x-transition">
                <v-col cols="5" md="5" sm="5" class="ml-n2">
                  <BaseTextField
                    :label="$t('common.search')"
                    :placeholder="$t('common.search')"
                    clearable
                    hide-details
                    v-model="search"
                    class="mx-auto"
                    single-line
                    v-show="expand"
                  />
                </v-col>
              </v-expand-x-transition>
              <v-spacer></v-spacer>
              <v-chip>
                {{ $t("producer-dashboard.sales-update-time") }}:
                {{
                  timerCountdown > 9 ? timerCountdown : "0" + timerCountdown
                }}s
              </v-chip>
            </template>
          </v-card-title>
          <v-card-text class="d-flex flex-row flex-wrap pl-4" fullscreen>
            <ResumeCard
              v-for="evento in tipo.activeItems"
              :evento="evento"
              :key="evento.idproduto"
              class="resume-card"
            />
            <ResumeCard
              v-for="evento in tipo.inactiveItems"
              :evento="evento"
              :key="evento.idproduto"
              closed
              class="resume-encerrados"
              color="grey--text text--darken-1 grey lighten-2"
            />
          </v-card-text>
        </v-col>
      </v-col>
    </v-row>
    <v-row dense justify="center" align-content="center">
      <v-col cols="12" align="center" class="mt-n3">
        <v-btn
          small
          color="tertiary"
          dark
          text
          :loading="$dashboard.loadingMore"
          @click="loadMoreEvents"
          v-if="!refreshLoading"
        >
          {{ $t("common.see-more") }}
          <v-icon size="18" class="floating">mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </fragment>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import displayHelpers from "@/mixins/breakpoints.mixins";
import ResumeCard from "@/components/cards/ResumeCard.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
export default {
  name: "ProducerResume",
  mixins: [displayHelpers],
  components: {
    ResumeCard,
    BaseTextField,
  },
  data() {
    return {
      page: 10,
      expand: false,
      search: "",
      timerInterval: null,
      timerCountdown: 60,
    };
  },
  computed: {
    ...mapActions(["setShowDetails"]),
    ...mapGetters([
      "storeSequencial",
      "isOpenModal",
      "dashEvent",
      "checkinEvent",
      "saleTicket",
      "dashEventLoading",
      "dashEventHasData",
    ]),
    percentCheckin() {
      if (Math.sign(this.checkinEvent.percentual_realizados) === -1) {
        return {
          text: "Realizados",
          value: Math.round(this.checkinEvent.percentual_realizados) + "%",
          class: "negative-percent",
        };
      } else {
        return {
          text: "Realizados",
          value: Math.round(this.checkinEvent.percentual_realizados) + "%",
          class: "positive-percent",
        };
      }
    },
    percentCheck() {
      if (Math.sign(this.checkinEvent.percentual_restantes) === -1) {
        return {
          text: "Restantes",
          value: Math.round(this.checkinEvent.percentual_restantes) + "%",
          class: "negative-percent",
        };
      } else {
        return {
          text: "Restantes",
          value: Math.round(this.checkinEvent.percentual_restantes) + "%",
          class: "positive-percent",
        };
      }
    },
    elevationSize() {
      return this.mdAndUp ? "0" : "0";
    },
    refreshLoading() {
      return (
        this.$dashboard.loadingEventosAtivos ||
        this.$dashboard.loadingEventosEncerrados
      );
    },
    activeEvents() {
      let events = [...this.$dashboard.eventosAtivos];
      return events.filter(
        event =>
          event.descricao.toLowerCase().includes(this.search?.toLowerCase()) &&
          (event.tipo == "INGRESSO" || event.tipo == "EVENTO")
      );
    },
    inactiveEvents() {
      let events = [...this.$dashboard.eventosEncerrados];
      return events.filter(
        event =>
          event.descricao.toLowerCase().includes(this.search?.toLowerCase()) &&
          (event.tipo == "INGRESSO" || event.tipo == "EVENTO")
      );
    },
    activeRecharges() {
      let events = [...this.$dashboard.eventosAtivos];
      return events.filter(
        event =>
          event.descricao.toLowerCase().includes(this.search?.toLowerCase()) &&
          event.tipo == "RECARGA"
      );
    },
    inactiveRecharges() {
      let events = [...this.$dashboard.eventosEncerrados];
      return events.filter(
        event =>
          event.descricao.toLowerCase().includes(this.search?.toLowerCase()) &&
          event.tipo == "RECARGA"
      );
    },
    activeProducts() {
      let events = [...this.$dashboard.eventosAtivos];
      return events.filter(
        event =>
          event.descricao.toLowerCase().includes(this.search?.toLowerCase()) &&
          event.tipo == "VOUCHER"
      );
    },
    inactiveProducts() {
      let events = [...this.$dashboard.eventosEncerrados];
      return events.filter(
        event =>
          event.descricao.toLowerCase().includes(this.search?.toLowerCase()) &&
          event.tipo == "VOUCHER"
      );
    },
    activeCourtesy() {
      let events = [...this.$dashboard.eventosAtivos];
      return events.filter(
        event =>
          event.descricao.toLowerCase().includes(this.search?.toLowerCase()) &&
          event.tipo == "CORTESIA"
      );
    },
    inactiveCourtesy() {
      let events = [...this.$dashboard.eventosEncerrados];
      return events.filter(
        event =>
          event.descricao.toLowerCase().includes(this.search?.toLowerCase()) &&
          event.tipo == "CORTESIA"
      );
    },
    hasEvents() {
      return this.activeEvents.length > 0 || this.inactiveEvents.length > 0;
    },
    hasRecharges() {
      return (
        this.activeRecharges.length > 0 || this.inactiveRecharges.length > 0
      );
    },
    hasProducts() {
      return this.activeProducts.length > 0 || this.inactiveProducts.length > 0;
    },
    hasCourtesy() {
      return this.activeCourtesy.length > 0 || this.inactiveCourtesy.length > 0;
    },
    tipos() {
      return [
        {
          value: "INGRESSO",
          text: this.$t("producer-dashboard.events"),
          check: this.hasEvents,
          activeItems: this.activeEvents,
          inactiveItems: this.inactiveEvents,
          headerButtons: true,
        },
        {
          value: "RECARGA",
          text: this.$t("producer-dashboard.cashless-recharges"),
          check: this.hasRecharges,
          activeItems: this.activeRecharges,
          inactiveItems: this.inactiveRecharges,
          headerButtons: !this.hasEvents,
        },
        {
          value: "VOUCHER",
          text: this.$t("producer-dashboard.products"),
          check: this.hasProducts,
          activeItems: this.activeProducts,
          inactiveItems: this.inactiveProducts,
          headerButtons: !this.hasEvents && !this.hasRecharges,
        },
        {
          value: "CORTESIA",
          text: this.$t("producer-dashboard.courtesies"),
          check: this.hasCourtesy,
          activeItems: this.activeCourtesy,
          inactiveItems: this.inactiveCourtesy,
          headerButtons:
            !this.hasEvents && !this.hasRecharges && !this.hasProducts,
        },
      ];
    },
  },
  methods: {
    async fetchDataAndStartTimer() {
      try {
        await this.$dashboard.getEventos("load", 10, this.storeSequencial);
      } catch (error) {
        console.error("Error fetching events:", error);
      } finally {
        this.startTimer();
      }
    },
    isAdmin() {
      if (this.$axios.getLocal("oe_user_info")?.data?.user_type === "admin") {
        return true;
      }
      return false;
    },
    startTimer() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.refreshEvents();
      }
      this.timerInterval = setInterval(async () => {
        this.timerCountdown -= 1;

        if (this.timerCountdown <= 0) {
          await this.$dashboard.getEventos("load", 10, this.storeSequencial);
          this.timerCountdown = 60;
        }
      }, 1000);
    },
    refreshEvents() {
      this.page = 10;
      sessionStorage.clear();
      this.$dashboard.getEventos("load", 10, this.storeSequencial);
    },
    loadMoreEvents() {
      this.page += 10;
      this.$dashboard.getEventos("loadMore", this.page, this.storeSequencial);
    },
  },
  watch: {
    "$store.getters.storeSequencial": function () {
      this.fetchDataAndStartTimer();
    },
  },
  mounted() {
    this.fetchDataAndStartTimer();
    if (
      this.$axios.getCookie("oe_jwt") &&
      this.$axios.getLocal("oe_user_info") &&
      !this.isAffiliate
    ) {
      const { user_type, status, perfil } =
        this.$axios.getLocal("oe_user_info").data;
      if (
        status === "ACEITE_TERMOS" &&
        (perfil === "LOJISTA" || user_type === "loja")
      ) {
        this.$termos.getTermosLojista();
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timerInterval);
  },
};
</script>
<style scoped>
.mdi-information-outline::before {
  height: 20px !important;
  width: 20px !important;
}

.fontDash-title {
  font-family: "Roboto", sans-serif;
  font-size: 1.5rem !important;
  font-weight: 600;
  letter-spacing: 0.0068em !important;
  margin-bottom: 20px;
}

.event-image {
  position: relative;
}
.event-image::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(20px) brightness(0.8);
  -webkit-backdrop-filter: blur(20px);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
}
</style>
